import { render, staticRenderFns } from "./picker-saleCategory.vue?vue&type=template&id=1c5128b4&"
import script from "./picker-saleCategory.vue?vue&type=script&lang=js&"
export * from "./picker-saleCategory.vue?vue&type=script&lang=js&"
import style0 from "./picker-saleCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports